// @ts-ignore
import React from "react";
import { Box, Typography, useTheme, Avatar } from "@mui/material";

interface ChatMessageProps {
  message: {
    body: string;
    message?: string;
    created_at: string;
    sender: { id: number; name: string; avatar?: string };
  };
  currentUserId: number;
  chatType: "individual" | "group" | "channel";
  onOpenInfo?: (sender: { id: number; name: string }) => void;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
                                                   message,
                                                   currentUserId,
                                                   chatType,
                                                   onOpenInfo,
                                                 }) => {
  const theme = useTheme();
  const isOwner = message.sender.id === currentUserId;

  // Format time like WhatsApp (e.g., 4:36 PM)
  const time = new Date(message.created_at).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  }).toLowerCase();

  return (
      <Box
          display="flex"
          flexDirection="column"
          alignItems={isOwner ? "flex-end" : "flex-start"}
          sx={{
            mb: 1.5,
            mx: 2,
            maxWidth: "85%",
            alignSelf: isOwner ? "flex-end" : "flex-start"
          }}

      >
        {chatType === "group" && !isOwner && (
            <Box display="flex" alignItems="center" gap={1} mb={0.5} ml={0.5}>
              <Avatar
                  src={message.sender.avatar}
                  sx={{
                    width: 28,
                    height: 28,
                    cursor: "pointer",
                    bgcolor: '#3f78e0'
                  }}
                  onClick={() => onOpenInfo?.(message.sender)}
              >
                {message.sender.name[0]}
              </Avatar>
              <Typography
                  variant="caption"
                  onClick={() => onOpenInfo?.(message.sender)}
                  sx={{
                    cursor: "pointer",
                    color: '#555',
                    fontWeight: 600,
                    fontSize: '0.8rem',
                    "&:hover": { textDecoration: "underline" },
                  }}
              >
                {message.sender.name}
              </Typography>
            </Box>
        )}


      {/*)}*/}


        {/*// <Typography variant="body1" sx={{ mb: 1.5 }}>*/}
        {/*//   {chatType === "group" || chatType === "channel"*/}
        {/*//     ? message.message*/}
        {/*//     : message.body}*/}
        {/*// </Typography>*/}


        <Box
            sx={{
              position: "relative",
              display: "inline-flex",
              flexDirection: "column",
              padding: "10px 14px",
              borderRadius: isOwner
                  ? "18px 4px 18px 18px"
                  : "4px 18px 18px 18px",
              backgroundColor: isOwner
                  ? '#3f78e0'
                  : '#ffffff',
              color: isOwner
                  ? '#fff'
                  : '#333',
              wordBreak: "break-word",
              boxShadow: "0 1px 1px rgba(0,0,0,0.08)",
              maxWidth: "100%",
              lineHeight: 1.4,
            }}
        >
          <Typography variant="body1" sx={{
            mb: 1.5,
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            fontSize: '1.1rem',
            lineHeight: 1.4,
          }}>
            {message.body || message.message}
          </Typography>

          <Box
              display="flex"
              justifyContent="flex-end"
              alignItems="flex-end"
              sx={{ mt: 0.5 }}
          >
            <Typography
                variant="caption"
                sx={{
                  opacity: 0.8,
                  fontSize: "0.65rem",
                  color: isOwner ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.6)',
                  lineHeight: 1,
                  textAlign: 'right',
                }}
            >
              {time}
            </Typography>
          </Box>
        </Box>
      </Box>
  );
};

export default ChatMessage;